/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainEntitiesDocumentsGameDocumentVersionContent } from './FxIdDomainEntitiesDocumentsGameDocumentVersionContent';
import {
    FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSON,
    FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSONTyped,
    FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSON,
    FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSONTyped,
} from './FxIdDomainEntitiesDocumentsGameDocumentVersionContent';
import type { FxIdDomainEntitiesDocumentsDocumentAccountAccept } from './FxIdDomainEntitiesDocumentsDocumentAccountAccept';
import {
    FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON,
    FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON,
    FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSONTyped,
} from './FxIdDomainEntitiesDocumentsDocumentAccountAccept';

/**
 * Представляет конкретную версию документа.
 * @export
 * @interface FxIdDomainEntitiesDocumentsGameDocumentVersion
 */
export interface FxIdDomainEntitiesDocumentsGameDocumentVersion {
    /**
     * Идентификатор версии.
     * @type {number}
     * @memberof FxIdDomainEntitiesDocumentsGameDocumentVersion
     */
    Id: number;
    /**
     * URL-адрес с контентом версии.
     * @type {string}
     * @memberof FxIdDomainEntitiesDocumentsGameDocumentVersion
     */
    Url: string;
    /**
     * 
     * @type {FxIdDomainEntitiesDocumentsGameDocumentVersionContent}
     * @memberof FxIdDomainEntitiesDocumentsGameDocumentVersion
     */
    Content?: FxIdDomainEntitiesDocumentsGameDocumentVersionContent | null;
    /**
     * Дата и время создания версии.
     * @type {Date}
     * @memberof FxIdDomainEntitiesDocumentsGameDocumentVersion
     */
    CreatedAt: Date;
    /**
     * Идентификатор родительского документа.
     * @type {number}
     * @memberof FxIdDomainEntitiesDocumentsGameDocumentVersion
     */
    DocumentId: number;
    /**
     * Коллекция подтверждений принятия этой версии пользователями.
     * @type {Array<FxIdDomainEntitiesDocumentsDocumentAccountAccept>}
     * @memberof FxIdDomainEntitiesDocumentsGameDocumentVersion
     */
    Accepts: Array<FxIdDomainEntitiesDocumentsDocumentAccountAccept>;
}

/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsGameDocumentVersion interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsGameDocumentVersion(value: object): value is FxIdDomainEntitiesDocumentsGameDocumentVersion {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('Url' in value) || value['Url'] === undefined) return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined) return false;
    if (!('DocumentId' in value) || value['DocumentId'] === undefined) return false;
    if (!('Accepts' in value) || value['Accepts'] === undefined) return false;
    return true;
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON(json: any): FxIdDomainEntitiesDocumentsGameDocumentVersion {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsGameDocumentVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'Url': json['Url'],
        'Content': json['Content'] == null ? undefined : FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSON(json['Content']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'DocumentId': json['DocumentId'],
        'Accepts': ((json['Accepts'] as Array<any>).map(FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON)),
    };
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON(json: any): FxIdDomainEntitiesDocumentsGameDocumentVersion {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionToJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionToJSONTyped(value?: FxIdDomainEntitiesDocumentsGameDocumentVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'Url': value['Url'],
        'Content': FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSON(value['Content']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'DocumentId': value['DocumentId'],
        'Accepts': ((value['Accepts'] as Array<any>).map(FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON)),
    };
}

